import { Component, Vue } from 'vue-property-decorator';

/**
 * A Mixin for components that implement pagination via graphql pagination.
 */

@Component
export default class PaginationMixin extends Vue {
  public readonly pageSize = 75;

  public after: string | null = null;
  public before: string | null = null;
  public first: number | null = this.pageSize;
  public last: number | null = null;

  public handlePreviousClick(startCursor: string) {
    this.after = null;
    this.first = null;
    this.before = startCursor;
    this.last = this.pageSize;
  }

  public handleNextClick(endCursor: string) {
    this.before = null;
    this.last = null;
    this.after = endCursor;
    this.first = this.pageSize;
  }
}
